module.exports = __webpack_public_path__ + "static/media/newskyline-course-ba.892f868c.jpg";